import { render } from "./RfmDashboard.vue?vue&type=template&id=1d57b450&scoped=true"
import script from "./RfmDashboard.vue?vue&type=script&lang=js"
export * from "./RfmDashboard.vue?vue&type=script&lang=js"

import "./RfmDashboard.vue?vue&type=style&index=0&id=1d57b450&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d57b450"]])

export default __exports__